// extracted by mini-css-extract-plugin
export default {"wrapper":"DocumentEditorToolbar_wrapper__4UnM4","root":"DocumentEditorToolbar_root__xard8","alignCenter":"DocumentEditorToolbar_alignCenter__CuUQ6"};